var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-row',[_c('b-col',{attrs:{"lg":"3","sm":"12"}},[_vm._t("leftSidebar")],2),_vm._v(" "),_c('b-col',{attrs:{"lg":"9","sm":"12"}},[_vm._t("heading"),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2"},[_vm._t("subTitle")],2)],1),_vm._v(" "),_vm._t("filters"),_vm._v(" "),_vm._t("table")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }